export const textFontSize = {
  xxl: "24px",
  xl: "20px",
  xl2: "21px",
  lg: "18px",
  md: "16px",
  re: "14px",
  sm: "12px",
  xs: "10px", 
};

/**
 * テキストカラー
 *
 * @see https://sketch.cloud/s/2b3Pe/a/nzjaYd
 */
export const textColor = {
  main: "#666666",
  subText01: "#8B97A8",
  subText02: "#C3CaD4",
  inversed: "#FFFFFF",
  mobileTitle: "#333333",
};

/**
 * プロダクトカラー
 *
 * @see https://sketch.cloud/s/2b3Pe/a/nzjaYd
 */
export const productColor = {
  // プライマリ
  primary: "#007BC3",
  primaryHover: "#038cdc",
  primaryHoverText: "#3145D1",
  primaryP10: "#0B4087",
  primaryP20: "#0A3878",
  primaryP30: "#007BC3",
  primaryM95: "#F2F5F9",
  primaryM90: "#E7ECF4",
  primaryM80: "#E7F1FD",
  // セカンダリ
  secondary: "#ED5D5D",
  secondaryHover: "#e44242",

  editAction: "#22AEE5",
  editActionHover: "#5dc7f1",
  deleteAction: "#ED5D5D",
  deleteActionHover: "#ec7878",
  copyAction: "#F8BF2D",
  copyActionHover: "#fbcf5e",
  approveAction: "#45D1D1",
  approveActionHover: "#79e2e2",
  confirmAction: "#007BC3",
  confirmActionHover: "#56aee2",
  header: "#F2F8FC",
};

/**
 * グレイスケール
 *
 * @see https://sketch.cloud/s/2b3Pe/a/lPRW8x
 */
export const grayScale = {
  gray100: "#333333",
  gray60: "#666666",
  gray50: "#999999",
  gray40: "#ADADAD",
  gray30: "#C1C1C1",
  gray20: "#DCDCDC",
  gray10: "#EAEAEA",
  gray05: "#F5F5F5",
  gray03: "#DCDCDC",
  gray01: "#666666",
};

/**
 * ユーティリティカラー
 *
 * @see https://sketch.cloud/s/2b3Pe/a/nzjaYd
 */
export const utilityColor = {
  transparent: "transparent",
  error: "#E95562",
  white: "#FFFFFF",
  black: "#000000",
  yellow: "#FADB04",
  disabled: "#C3CAD4",
  mobileIcon: "#333333",
  note: "#ED5D5D",
};

/**
 * グリッド
 *
 * @see https://sketch.cloud/s/2b3Pe/a/xamY8J
 */
export const gridCol = {
  grid01: "8.333333%",
  grid02: "16.666667%",
  grid03: "25%",
  grid04: "33.333333%",
  grid05: "41.666667%",
  grid06: "50%",
  grid07: "58.333333%",
  grid08: "66.666667%",
  grid09: "75%",
  grid10: "83.333333%",
  grid11: "91.666667%",
  grid12: "100%",
};

export const backgroundColor = {
  main: "#F5F6F7",
};

/**
 * レイヤー
 *
 * @see https://sketch.cloud/s/2b3Pe/a/xamY8J
 */
export const layer = {
  layer01: "0 0 2px 0 rgba(0,0,0,0.12)",
  layer02: "0 1px 3px 0 rgba(0,0,0,0.12)",
  layer03: "0 2px 5px 0 rgba(0,0,0,0.12)",
  layer04: "0 3px 8px 0 rgba(0,0,0,0.12)",
  layer05: "0 5px 12px 0 rgba(0,0,0,0.12)",
  layer06: "0px 1px 8px rgba(102,102,102,0.2)",
};
/**
 * Icon Color
 */
export const iconColor = {
  gray: "#CCCCCC",
  grayhover: "#777777",
  grayArrow: "#979797",
  red: "#E95562",
  blue: "#0D4796",
};

export const fontFamily = "'Noto Sans JP', sans-serif";

export const customButtonColor = {
  green: "#45D1D1",
  yellow: "#F8BF2D",
  red: "#ED5D5D",
  disabled: "#DCDCDC",
  blue: "#22AEE5",
  disabledSubButton: "#C4C4C4",
};

export const statusApproval = {
  approved: "#0fbf00",
  doNotKnown: "#ff6600",
  rejected: "#e44242",
};

export default productColor;
